<header class="header-gallery">
  <div class="pt-topbar bg-primary header-gallery__slider">
    <figure class="ps-lg-0 pt-3" (mousewheel)="preventBack($event)">
      @if ((header().images?.length || 0) > 1) {
        <swiper-container init="false" #swiper>
          @for (image of sliderImages(); track $index; let i = $index) {
            <swiper-slide class="swiper-slide">
              <!--<img [src]="image.url" alt="" />-->

              <fstr-image
                [attr.data-object-position]="image?.anchor"
                [image]="image"
                [priority]="true"
                [width]="1200"
                [height]="1200"
                [mode]="'max'"
              ></fstr-image>
            </swiper-slide>
          }
        </swiper-container>
      }

      @if (header().images?.length === 1) {
        <fstr-image
          class="single-image"
          [image]="header().images?.[0]!"
          [attr.data-object-position]="header().images?.[0]?.anchor"
          [priority]="true"
          [width]="1200"
          [height]="1200"
          [mode]="'max'"
        ></fstr-image>
      }
    </figure>
  </div>

  <main class="container d-flex gap-3 gap-xl-5 header-gallery__main">
    @if (allowSlideNext || allowSlidePrev) {
      <div class="d-none d-md-flex gap-1 header-gallery__controls mt-3">
        <button class="button button-icon button--primary-subtle button--lg" (click)="slidePrev()" [disabled]="isBeginning">
          <fstr-icon anchor="line-icon-arrow-left"></fstr-icon>
          <span class="sr-only">Vorige</span>
        </button>
        <button class="button button-icon button--primary-subtle button--lg" (click)="slideNext()" [disabled]="isEnd">
          <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
          <span class="sr-only">Volgende</span>
        </button>
      </div>
    }

    <div class="flex-grow-1 header-gallery__card header-card">
      <div class="header-card__header">
        <h1 class="h3 text-max-width-xs">{{ header().title }}</h1>

        @if (header().button?.url || header().secondaryButton?.url) {
          <div class="mt-3 mt-sm-4 d-flex flex-wrap gap-2">
            @if (header().button?.url) {
              <fstr-link [button]="header().button!" [cssClasses]="'button button--primary'" [showText]="false">
                @if (header().button?.text) {
                  <span>{{ header().button?.text }}</span>
                }
                @if (false) {
                  <fstr-icon [anchor]="'line-icon-arrow-down'"></fstr-icon>
                }
              </fstr-link>
            }
            @if (header().secondaryButton?.url) {
              <fstr-link [button]="header().secondaryButton!" [cssClasses]="'button button--primary-subtle'" [showText]="false">
                @if (header().secondaryButton?.text) {
                  <span>{{ header().secondaryButton?.text }}</span>
                }
                @if (false) {
                  <fstr-icon [anchor]="'line-icon-arrow-down'"></fstr-icon>
                }
              </fstr-link>
            }
          </div>
        }
      </div>

      @if (header().intro; as text) {
        <div class="header-card__content">
          <!--<p class="text-max-width-xs">
            {{ header().intro }}
          </p>-->

          <div
            class="markdown-content text-max-width-xs"
            fstrDynamicContent
            [innerHTML]="text | resizeHtmlImages | stripEmbed: undefined | safe"
          ></div>
        </div>
      }

      <!--@for (button of header().buttons; track $index) {
        <fstr-link [button]="button" [cssClasses]="'button button--primary'"></fstr-link>
      }-->
    </div>
  </main>
</header>
